import { Fragment } from "react";

import { cn } from "@/lib/cn";

import { Appear } from "@/components/landing/Appear";
import { RollingNumber } from "@/components/landing/RollingNumber";

const STATS = [
  { value: "3 года", label: "Разработки продукта" },
  { value: "$4M +", label: "Общий объем сделок" },
  { value: "99.8%", label: "Работа без сбоев" },
  { value: "10%/мес", label: "Базовая доходность", accent: true },
];

export const TrustStatsSection = () => (
  <section
    id="about"
    className="landing-container scroll-mt-[5.625rem] py-[8.75rem] max-md:py-20"
  >
    <Appear
      as="p"
      className="text-landing-ink/71 max-w-[31.25rem] text-[0.875rem] leading-[1.5] font-medium"
    >
      Автоматическая торговая система для тех, кто не хочет следить за графиками. Деньги остаются на
      вашей бирже OKX, Spider управляет сделками в рамках риска и берет комиссию только с прибыли.
    </Appear>

    {/* В сетке 2x2 разделители стали бы её же ячейками */}
    <div className="mt-36 flex items-center gap-10 max-lg:mt-12 max-lg:grid max-lg:grid-cols-2 max-lg:gap-x-6 max-lg:gap-y-10">
      {STATS.map((stat, index) => (
        <Fragment key={stat.value}>
          {index > 0 && (
            <div
              aria-hidden
              className="h-[6.1875rem] w-px shrink-0 bg-[rgb(0_0_0/0.2)] max-lg:hidden"
            />
          )}
          <div className="flex flex-col gap-4">
            <RollingNumber
              value={stat.value}
              className={cn(
                "text-[3.5rem] leading-none font-medium tracking-[-0.03em] whitespace-nowrap max-lg:text-[2.75rem] max-md:text-[2rem]",
                stat.accent ? "landing-gradient-text" : "text-landing-ink"
              )}
            />
            <span className="text-landing-ink/60 text-[0.875rem] leading-none font-medium whitespace-nowrap max-lg:leading-[1.3] max-lg:whitespace-normal">
              {stat.label}
            </span>
          </div>
        </Fragment>
      ))}
    </div>
  </section>
);
